'use client'

import { differenceInDays } from 'date-fns'
import { usePostHog } from 'posthog-js/react'
import { useEffect, useState } from 'react'

import { LineChartData, TimeScale } from '../../../types/Dashboard/types'

export const useResponsiveLineChartLogic = (
  data: LineChartData | undefined,
  dataKeys: string[] | undefined,
  timeScale: TimeScale | undefined,
) => {
  const [visibility, setVisibility] = useState<number[]>(new Array(dataKeys?.length ?? 1).fill(1))
  const [xAxisFormat, setXAxisFormat] = useState<string>('M/yy')
  const [xTooltipFormat, setXTooltipFormat] = useState<string>('M/d/yy')
  const posthog = usePostHog()

  useEffect(() => {
    const newVisibility = new Array(dataKeys?.length ?? 1).fill(1)
    setVisibility(newVisibility)
  }, [dataKeys?.length])

  useEffect(() => {
    if (data && data.length > 0) {
      const sortedData = [...data].sort((a, b) => {
        const dateA = a?.date ?? 0
        const dateB = b?.date ?? 0
        return dateA - dateB
      })

      const firstDateMs = sortedData[0]?.date ?? Date.now()
      const lastDateMs = sortedData[sortedData.length - 1]?.date ?? Date.now()

      const firstDate = new Date(firstDateMs)
      const lastDate = new Date(lastDateMs)

      const diff = Math.abs(differenceInDays(firstDate, lastDate))

      if (diff === 0) {
        setXAxisFormat('H:mm')
        setXTooltipFormat('MMM d H:mm')
      } else if (diff <= 7) {
        setXAxisFormat('M/d')
        setXTooltipFormat('MMM d H:mm')
      } else if (diff < 150) {
        setXAxisFormat('M/d')
        setXTooltipFormat('MMM d, yyyy')
      } else {
        setXAxisFormat('M/yy')
        setXTooltipFormat('MMM d, yyyy')
      }
    }
  }, [data])

  useEffect(() => {
    if (timeScale && timeScale !== 'All') {
      posthog.capture('time scale change')
    }
  }, [timeScale, data, posthog])

  return { setVisibility, visibility, xAxisFormat, xTooltipFormat }
}
